(() => {
  const DRAWER_SELECTOR = '#menuDrawer';

  function getDrawer() {
    return document.querySelector(DRAWER_SELECTOR);
  }

  function setSummaryExpanded(details, expanded) {
    const summary = details.querySelector(':scope > summary');
    if (summary) {
      summary.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }
  }

  function closeDetails(details) {
    if (!details) return;

    details.classList.remove('is-open');
    details.open = false;
    details.removeAttribute('open');
    setSummaryExpanded(details, false);

    details.querySelectorAll('details').forEach((child) => {
      child.classList.remove('is-open');
      child.open = false;
      child.removeAttribute('open');
      setSummaryExpanded(child, false);
    });
  }

  function openDetails(details) {
    if (!details) return;

    details.classList.add('is-open');
    details.open = true;
    setSummaryExpanded(details, true);
  }

  function getMenuItem(details) {
    return details.closest('li');
  }

  function closeSiblingDetails(details) {
    const level = details.dataset.level;
    const currentItem = getMenuItem(details);

    if (!level || !currentItem || !currentItem.parentElement) return;

    const list = currentItem.parentElement;
    const siblingItems = Array.from(list.children).filter((item) => item !== currentItem);

    siblingItems.forEach((item) => {
      const siblingDetails = Array.from(
        item.querySelectorAll(`details[data-level="${level}"]`)
      ).filter((candidate) => {
        return getMenuItem(candidate) === item;
      });

      siblingDetails.forEach(closeDetails);
    });
  }

  function normalizeDrawer() {
    const drawer = getDrawer();
    if (!drawer) return;

    drawer.querySelectorAll('details').forEach((details) => {
      if (details.classList.contains('is-open')) {
        details.open = true;
        setSummaryExpanded(details, true);
      } else if (details.open) {
        closeDetails(details);
      }
    });
  }

  document.addEventListener(
    'click',
    (event) => {
      const drawer = getDrawer();
      if (!drawer || !drawer.contains(event.target)) return;

      const summary = event.target.closest('summary');
      if (!summary || !drawer.contains(summary)) return;

      const details = summary.closest('details');
      if (!details) return;

      window.setTimeout(() => {
        if (details.classList.contains('is-open')) {
          openDetails(details);
          closeSiblingDetails(details);
        } else {
          closeDetails(details);
        }

        normalizeDrawer();
      }, 0);

      window.setTimeout(normalizeDrawer, 360);
    },
    true
  );

  document.addEventListener('click', (event) => {
    if (
      event.target.closest('.js-menu-drawer-trigger') ||
      event.target.closest('.js-menu-drawer-btn-close') ||
      event.target.closest('.js-menu-drawer-overlay')
    ) {
      window.setTimeout(normalizeDrawer, 80);
      window.setTimeout(normalizeDrawer, 380);
    }
  });
})();